import Benefits from '../components/Home/Benefits';
import Hero from '../components/Home/Hero';
import HowItWorks from '../components/Home/HowItWorks';
import Services from '../components/Home/Services';
import Testimonials from '../components/Home/Testimonials';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <HowItWorks />
      <Benefits />
      <Testimonials />
    </>
  );
};

export default Home;
